





































import { Component, Vue } from 'vue-property-decorator';
@Component({})
export default class DesktopMech extends Vue {
  /* TODO: Move data to service */
  private data() {
    return {
      desktopAssets: {
        elbowA: {
          url: require('../assets/home-mech/desktop/desktop-elbow-1_56x112.png'),
          alt: 'Desktop Elbow 1',
        },
        neckA: {
          url: require('../assets/home-mech/desktop/desktop-neck-1_104x28.png'),
          alt: 'Desktop neck 1',
        },
        neckB: {
          url: require('../assets/home-mech/desktop/desktop-neck-2_74x28.png'),
          alt: 'Desktop neck 2',
        },
        elbowB: {
          url: require('../assets/home-mech/desktop/desktop-elbow-2_54x48.png'),
          alt: 'Desktop Elbow 2',
        },
        valveA: {
          url: require('../assets/home-mech/mobile/mobile-valve-1_80x80.png'),
          alt: 'mobile valve 1',
        },
        neckC: {
          url: require('../assets/home-mech/desktop/desktop-neck-3_34x166.png'),
          alt: 'Desktop neck 3',
        },
        neckD: {
          url: require('../assets/home-mech/desktop/desktop-neck-4_338x18.png'),
          alt: 'Desktop neck 4',
        },
        neckE: {
          url: require('../assets/home-mech/desktop/desktop-neck-5_60x75.png'),
          alt: 'Desktop neck 5',
        },
        neckF: {
          url: require('../assets/home-mech/desktop/desktop-neck-6_300x18.png'),
          alt: 'Desktop neck 6',
        },
        elbowC: {
          url: require('../assets/home-mech/desktop/desktop-elbow-3_74x72.png'),
          alt: 'Desktop Elbow 3',
        },
      },
    };
  }
}
